import { Component, Input, OnDestroy, OnInit, NgZone, inject } from '@angular/core';
import { AppointmentType, Department, IGeneralSettings, SourceSystem } from '@signal/asp-data-commons';
import { MatDialog } from '@angular/material/dialog';
import { AppointmentSummaryDialogComponent } from '../../appointment-summary-dialog/appointment-summary-dialog.component'
import { ConfirmDialogComponent } from '../../../confirm-dialog/confirm-dialog.component';
import { AppointmentService } from '../../../../../shared/services/appointment.service';
import { Observable } from 'rxjs';
import * as fromSettingSelector from '../../../../../store/settings/settings.selectors';
import { IDashboardDetails, ScheduleDashboardState } from '../../../../../store/schedule-dashboard/schedule-dashboard.reducer';
import { Store } from '@ngrx/store';
import * as util from '../../../../../shared/services/util.service';
import { DateTime } from 'luxon';
import * as fromScheduleDashboardActions from '../../../../../store/schedule-dashboard/schedule-dashboard.action';
import * as fromScheduleDashboardSelector from '../../../../../store/schedule-dashboard/schedule-dashboard.selectors';
import { SubscriptionList } from 'src/app/modules/shared/models/asp.types';
import { SettingsState } from 'src/app/modules/store/settings/settings.reducer';
import { TranslateService } from '@ngx-translate/core';
import { titleCase } from '../../../../../shared/services/util.service';
import { getDeletePendingForTestdrive } from 'src/app/modules/store/sales-appointment/sales-appointment.adapter';

@Component({
  selector: 'app-appointment-card',
  templateUrl: './appointment-card.component.html',
  styleUrls: ['./appointment-card.component.scss']
})
export class AppointmentCardComponent implements OnInit, OnDestroy {

  @Input() appointment: any;
  @Input() allInventoryVehicles: any[];
  private subs: SubscriptionList = {};
  makeModelYearText: string;
  appointmentHrs: number = 0;
  dealerSettings$: Observable<IGeneralSettings>;
  dashboardDetails$: Observable<IDashboardDetails>;
  dashboardDetails: IDashboardDetails;
  dateFormat: string = 'yyyy-MM-dd';
  private readonly ngZone = inject(NgZone);
  salesApptColorObj = {
    [AppointmentType.TEST_DRIVE]: '#AED5EB',
    [AppointmentType.DELIVERY]: '#C9FFF5',
    [AppointmentType.LEARNING]: '#F4B8B2',
    [AppointmentType.VEHICLE_INQUIRY]: '#FFDCA3',
  };
  constructor(private settingsState: Store<SettingsState>, public dialog: MatDialog, private readonly appointmentService: AppointmentService, private scheduleDashboardState: Store<ScheduleDashboardState>,
    private readonly translate: TranslateService) { }

  ngOnInit(): void {
    if (this.appointment) {
      this.makeModelYearText = util.getMakeModelYearText(this.appointment?.vehicle);
      this.makeModelYearText = this.makeModelYearText ? this.makeModelYearText : this.appointment?.vehicle?.vin;
      if (this.appointment.appointmentType === AppointmentType.SERVICE && this.appointment.totalLaborHours) {
        this.appointmentHrs = this.appointment.totalLaborHours;
      }
    }
    this.setUpStore();
  }

  setUpStore() {

    this.dealerSettings$ = this.settingsState.select(fromSettingSelector.selectSettings);
    this.dashboardDetails$ = this.scheduleDashboardState.select(fromScheduleDashboardSelector.selectScheduleDashboardDetails);
    this.subs.dashboardDetails = this.dashboardDetails$.subscribe(details => {
      this.dashboardDetails = details;
    });
    if (this.appointment.appointmentType === AppointmentType.TEST_DRIVE) {
      this.subs.dealerSettings = this.dealerSettings$.subscribe(data => {
        if (data)
          this.appointmentHrs = data.time.testdriveAppointmentDuration / 60
      }
      );
    }
    if (this.appointment.appointmentType === AppointmentType.DELIVERY) {
      this.subs.delievryDealerSettings = this.dealerSettings$.subscribe(data => {
        if (data)
          this.appointmentHrs = data.time.deliveryAppointmentDuration / 60
      })
    }

  }

  refresh() {
    const startDateForSlot = DateTime.fromFormat(this.dashboardDetails.endDate, this.dateFormat).startOf('month').toFormat(this.dateFormat);
    const endDateForSlot = DateTime.fromFormat(this.dashboardDetails.endDate, this.dateFormat).endOf('month').toFormat(this.dateFormat);
    this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.LoadScheduleDashboardSlot({ department: 'Service', endDate: endDateForSlot, startDate: startDateForSlot }));
    if (this.dashboardDetails.viewMode !== 'Month') {
      this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.LoadScheduleDashboardAppointments({
        department: 'Service', endDate: this.dashboardDetails.endDate,
        startDate: this.dashboardDetails.startDate, filters: this.dashboardDetails.filterValue, viewMode: this.dashboardDetails.viewMode
      }));
    }

  }

  resyncAppointment(appointment) {
  }

  openAppointmentSummaryDialog() {
    this.ngZone.runOutsideAngular(() => {
    this.appointmentService
      .get(this.appointment.appointmentType, this.appointment.appointmentId).subscribe(resp => {
        if (resp.data) {
          const data = {...resp.data, department: (resp.data.appointmentType === "Service")? Department.SERVICE: Department.SALES, allInventoryVehicles: this.allInventoryVehicles};
          const widthVal = resp.data.appointmentType === AppointmentType.SERVICE ? "85rem" : "45rem";
          const heightVal = resp.data.appointmentType === AppointmentType.SERVICE ? "42rem" : "35rem";
          const dialogRef = this.dialog.open(AppointmentSummaryDialogComponent, {
            data: data,
            panelClass: 'appointment-summary-dialog',
            width: widthVal,
            height: heightVal
          });

          this.subs.dialog = dialogRef.afterClosed().subscribe(result => {
            if (result === 'cancel') {
              const dialogRef2 = this.dialog.open(ConfirmDialogComponent, {
                width: '400px',
                height: '220px',
                data: {
                  popupTitle: 'serviceSchedule.cancelAppointment',
                  popupBodyText: 'serviceSchedule.areYouSureYouWantToCancelThisAppointment'
                },
                panelClass: 'asp-modal-container'
              });

              this.subs.dialog2 = dialogRef2.afterClosed().subscribe((result) => {
                if (result.action === 'confirm') {
                  this.subs.cancel = this.appointmentService.cancel(this.appointment).subscribe((data) => {
                    this.refresh();
                  });
                }
              });
            }
          });
        }
      })
    })
  }
  getTranslation(value, key) {
    if (value) {
      value = value.replace(' ', '')
      return this.translate.instant(`${key}.${value.toLowerCase()}`)
    }
    return value;
  }
  getTranslationForTransportation(value) {
    const transportationTypeCode = ["drop off", "drop-off", "remote", "shuttle", "wait", "waiter", "loan", "loaner", "rental", "dealer"];
    return value && (transportationTypeCode.includes(value.toLowerCase())) ? this.translate.instant(`service.${titleCase(value)}`) : value;
  }

  getCustomerDisplayName(): string {
    return util.getCustomerDisplayName(this.appointment?.customer);
  }

  getDeletePendingStatus() {
    return getDeletePendingForTestdrive(this.appointment, this.allInventoryVehicles);
  }
  getAppointmentTypeColor(): string {
    return this.salesApptColorObj[this.appointment?.appointmentType] || '#FFFFFF';
  }

  ngOnDestroy(): void {
    util.unsubscribeSubscriptions(this.subs);
  }


}
